export default __webpack_public_path__ + "static/media/flag-fr.7e9f20d6.svg";